export const getTime = (timeStampSec: string) => {
  return new Date(parseInt(timeStampSec) * 1000);
};
